/**
 * Geolocation Popup - "Greetings from ANCHOR" Design
 * Single-view popup with delivery/currency selection
 */

class GeoPopup {
  constructor() {
    this.cookiePrefix = 'anchor_geo_';
    this.cookieDuration = 365;
    this.config = window.GeoPopupConfig || {};
    this.popup = null;
    this.deliverySelect = null;
    this.currencySelect = null;
    this.languageSelect = null;
  }

  setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + expires.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  init() {
    this.popup = document.getElementById('geolocationPopup');
    if (!this.popup) return;

    if (this.getCookie(this.cookiePrefix + 'dismissed') === 'true' ||
        localStorage.getItem(this.cookiePrefix + 'dismissed') === 'true') return;

    this.deliverySelect = document.getElementById('geoDeliverySelect');
    this.currencySelect = document.getElementById('geoCurrencySelect');
    this.languageSelect = document.getElementById('geoLanguageSelect');

    this.attachEvents();
    this.showPopup();
  }

  attachEvents() {
    var self = this;

    /* Close button */
    var closeBtn = this.popup.querySelector('.geo-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { self.dismiss(); });
    }

    /* Overlay click */
    var overlay = this.popup.querySelector('.geo-popup__overlay');
    if (overlay) {
      overlay.addEventListener('click', function() { self.dismiss(); });
    }

    /* Continue Shopping */
    var continueBtn = document.getElementById('geoContinueBtn');
    if (continueBtn) {
      continueBtn.addEventListener('click', function() { self.dismiss(); });
    }

    /* Log In & Join - also dismiss, save selection and submit localization */
    var loginBtn = document.getElementById('geoLoginBtn');
    if (loginBtn) {
      loginBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self.saveSelection();
        self.submitLocalization();
      });
    }

    /* Delivery dropdown change -> sync currency dropdown */
    if (this.deliverySelect) {
      this.deliverySelect.addEventListener('change', function() {
        self.syncCurrencyFromDelivery();
      });
    }

    /* Currency dropdown change -> apply via AnchorCurrency converter */
    if (this.currencySelect) {
      /* Initialize dropdown to current currency */
      if (window.AnchorCurrency) {
        try { this.currencySelect.value = window.AnchorCurrency.get(); } catch (e) {}
      }
      this.currencySelect.addEventListener('change', function() {
        var val = self.currencySelect.value;
        if ((val === 'USD' || val === 'KRW') && window.AnchorCurrency) {
          window.AnchorCurrency.set(val);
        } else {
          self.syncDeliveryFromCurrency();
        }
      });
    }

    /* ESC key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.popup && self.popup.classList.contains('active')) {
        self.dismiss();
      }
    });
  }

  showPopup() {
    var self = this;
    setTimeout(function() {
      self.popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    }, 600);
  }

  dismiss() {
    this.setCookie(this.cookiePrefix + 'dismissed', 'true', this.cookieDuration);
    localStorage.setItem(this.cookiePrefix + 'dismissed', 'true');
    this.popup.classList.remove('active');
    document.body.style.overflow = '';

    /* Submit localization only if country changed, preserve current locale */
    this.submitLocalization(true);
  }

  /**
   * When delivery country changes, update currency dropdown to match
   */
  syncCurrencyFromDelivery() {
    if (!this.deliverySelect || !this.currencySelect) return;
    var selectedCountry = this.deliverySelect.value;
    this.currencySelect.value = selectedCountry;
  }

  /**
   * When currency changes, update delivery dropdown to match
   */
  syncDeliveryFromCurrency() {
    if (!this.deliverySelect || !this.currencySelect) return;
    var selectedCountry = this.currencySelect.value;
    this.deliverySelect.value = selectedCountry;
  }

  /**
   * Save selection cookie
   */
  saveSelection() {
    if (this.deliverySelect) {
      this.setCookie(this.cookiePrefix + 'country', this.deliverySelect.value, this.cookieDuration);
    }
    if (this.languageSelect) {
      this.setCookie(this.cookiePrefix + 'locale', this.languageSelect.value, this.cookieDuration);
    }
    this.setCookie(this.cookiePrefix + 'dismissed', 'true', this.cookieDuration);
    localStorage.setItem(this.cookiePrefix + 'dismissed', 'true');
  }

  /**
   * Submit Shopify localization form if country differs from current
   * @param {boolean} preserveLocale - if true, keep the current locale instead of switching based on country
   */
  submitLocalization(preserveLocale) {
    if (!this.deliverySelect) return;

    var selectedCountry = this.deliverySelect.value;
    var currentCountry = this.config.userCountry || '';

    /* Save selection to cookie */
    this.setCookie(this.cookiePrefix + 'country', selectedCountry, this.cookieDuration);

    /* Determine locale */
    var localeInput = document.getElementById('geoLocaleCode');
    var currentLocale = localeInput ? localeInput.value : '';
    var targetLocale;

    /* Prefer the manually selected language from the dropdown when available */
    var manualLocale = this.languageSelect ? this.languageSelect.value : '';

    if (manualLocale) {
      targetLocale = manualLocale;
    } else if (preserveLocale) {
      /* Keep current locale when dismissing */
      targetLocale = currentLocale;
    } else {
      /* Determine locale based on country (only when explicitly choosing via Login button) */
      var map = (this.config && this.config.countryLocaleMap) || { 'KR': 'ko' };
      var defaultLocale = (this.config && this.config.defaultLocale) || 'en';
      targetLocale = map[selectedCountry] || defaultLocale;
    }

    /* Submit form if country or locale changed */
    if (selectedCountry !== currentCountry || targetLocale !== currentLocale) {
      var form = document.getElementById('geoLocalizationForm');
      var countryInput = document.getElementById('geoCountryCode');
      if (form && countryInput) {
        countryInput.value = selectedCountry;
        if (localeInput) localeInput.value = targetLocale;
        form.submit();
      }
    }
  }

  /* Static helpers */
  static getCookieStatic(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  static deleteCookieStatic(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }

  static getPreferences() {
    return {
      country: GeoPopup.getCookieStatic('anchor_geo_country'),
      dismissed: GeoPopup.getCookieStatic('anchor_geo_dismissed') === 'true'
    };
  }

  static clearPreferences() {
    GeoPopup.deleteCookieStatic('anchor_geo_dismissed');
    GeoPopup.deleteCookieStatic('anchor_geo_country');
    localStorage.removeItem('anchor_geo_dismissed');
    localStorage.removeItem('anchor_geo_country');
  }
}

/* Initialize */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.geoPopup = new GeoPopup();
    window.geoPopup.init();
  });
} else {
  window.geoPopup = new GeoPopup();
  window.geoPopup.init();
}

/* Global helpers */
window.GeoPopupHelper = {
  getPreferences: GeoPopup.getPreferences,
  clear: GeoPopup.clearPreferences,
  forceShow: function() {
    GeoPopup.clearPreferences();
    location.reload();
  }
};
